import React, { useState, useEffect } from 'react';
import { Button, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { useRootStore } from '../../../stores/BridgeProvider';
import {
  StyledForm,
  WideBox,
  FlexDiv,
  ButtonFlex,
  FormRow,
} from '../../styles/styles';
import Spinner from '../../util/Spinner';
import {
  formFieldGenerator,
  initialValueGenerator,
} from '../../util/TemplateUtils';
import { DealTemplateSchema } from '../../../validation';

const NewDealFromTemplate = ({ templateId }) => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(false);
  const [dealTemplate, setDealTemplate] = useState(null);
  useEffect(() => {
    const initialize = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/deal-template/${templateId}`,
        );
        setDealTemplate(data);
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };

    initialize();
  }, [templateId]);

  if (isLoading || !dealTemplate) return <Spinner />;
  const { Description, Name, DealTemplateId, TemplateJSON } = dealTemplate;
  const { items } = TemplateJSON;
  const initialValues = initialValueGenerator(items);
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={DealTemplateSchema(items)}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        try {
          // setLoading(true);
          const { data } = await authStore.request.post(
            `${process.env.REACT_APP_API}/api/create-deal-from-template`,
            {
              dealTemplateId: DealTemplateId,
              values,
            },
          );
          const { id } = data;
          resetForm();
          history.push(`/deal/${id}`);
        } catch (e) {
          console.error(e);
        }
        setSubmitting(false);
        // setLoading(false);
      }}
      render={formikProps => {
        const fieldArray = items.map((fieldObj, i) => (
          <FormRow
            style={{
              display: 'inline-block',

              width: fieldObj.width ? `${fieldObj.width}%` : '100%',
            }}
          >
            {formFieldGenerator({ fieldObj, formikProps, index: i })}
          </FormRow>
        ));

        const { handleSubmit, isSubmitting, isValid } = formikProps;
        return (
          <FlexDiv>
            <WideBox style={{ minWidth: '700px' }} showoverflow={1}>
              <StyledForm onSubmit={handleSubmit}>
                <Typography variant="h2" gutterBottom>
                  {Name}
                </Typography>
                <Typography variant="h4">{Description}</Typography>
                <div style={{ textAlign: 'left', width: '100%' }}>
                  {fieldArray}
                </div>

                <ButtonFlex>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    size="large"
                    style={{ marginTop: '1.2rem', marginBottom: '1.2rem' }}
                    disabled={!isValid || isSubmitting}
                  >
                    Submit
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    style={{ marginTop: '1.2rem', marginBottom: '1.2rem' }}
                    onClick={() => history.goBack()}
                  >
                    Cancel
                  </Button>
                </ButtonFlex>
              </StyledForm>
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default NewDealFromTemplate;
